import React, { Component } from 'react'
import { Button, Checkbox, Modal, Popconfirm, Select } from 'antd'
import _ from 'lodash'

import './DocumentSelectModal.scss'

const { Option } = Select

export default class DocumentSelectModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedValue: undefined,
            popconfirmVisible: false
        }

        this.handleSelectChange = this.handleSelectChange.bind(this)
        this.handleModalSubmit = this.handleModalSubmit.bind(this)
    }

    handlePopconfirmVisibleChange(disabled, popconfirmVisible) {
        if (disabled) {
            this.setState({ popconfirmVisible: false })
        } else {
            this.setState({ popconfirmVisible })
        }
    }

    handleSelectChange(value, label) {
        this.setState({ selectedValue: value })
    }

    handleModalSubmit() {
        const { onConfirm } = this.props
        const { selectedValue } = this.state

        onConfirm(selectedValue)
    }

    componentDidUpdate(prevProps, prevState) {
        const { visible } = this.props
        if (prevProps.visible !== visible)
            this.setState({ selectedValue: undefined })
    }

    renderDocumentList() {
        const { documentList } = this.props

        return _.map(documentList, (doc, idx) => (
            <Option key={doc._id} value={doc._id}>{doc.name}</Option>
        ))
    }

    render() {
        const { visible, importContent, importTAndC, onCheckboxChange, onCancel, modalBtnText } = this.props
        const { selectedValue, popconfirmVisible } = this.state
        const isBtnDisabled= (!importContent && !importTAndC) || _.isEmpty(selectedValue)

        return (
            <Modal
                width="60%"
                wrapClassName="DocumentSelectModal"
                visible={visible}
                footer={null}
                onCancel={onCancel}
            >
                <p className="label">Please select the document and the field that you want to import:</p>
                <div className="selector">
                    <Select
                        value={selectedValue}
                        placeholder="Select document" 
                        dropdownMatchSelectWidth={false}
                        onChange={this.handleSelectChange}
                    >
                        {this.renderDocumentList()}
                    </Select>
                </div>
                <div className="checkbox-gp">
                    <Checkbox checked={importContent} onChange={() => onCheckboxChange('importContent')}>Content</Checkbox>
                    <Checkbox checked={importTAndC} onChange={() => onCheckboxChange('importTAndC')}>Terms And Conditions</Checkbox>
                </div>
                <div className="footer">
                    <Popconfirm
                        visible={popconfirmVisible}
                        placement="bottom"
                        title="This action will overwrite all the current document contents, are you sure?"
                        onVisibleChange={this.handlePopconfirmVisibleChange.bind(this, (selectedValue === undefined))}
                        onConfirm={this.handleModalSubmit}
                    >
                        <Button type="primary" size="large" disabled={isBtnDisabled}>{modalBtnText}</Button>
                    </Popconfirm>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/DocumentSelectModal/DocumentSelectModal.js